export default __webpack_public_path__ + "static/media/iconTrash.6973dd3c.svg";